import { Component, OnInit, ViewChild } from '@angular/core';
import gql from 'graphql-tag';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { AuditoriaService } from 'src/app/services/auditoria.service';
import { cliente_proveedor } from 'src/app/shared/object/cliente_proveedor.model';
import { maquinaJoin } from 'src/app/shared/object/maquina_join.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { AuditoriaInput } from '../../configuracion-sistema/auditoria/lista-auditoria/lista-auditoria.component';

@Component({
  selector: 'app-mantenedor-clientes-modal-resumen',
  templateUrl: './modal-resumen.component.html',
  styleUrls: ['../clientes.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class MantenedorClientesModalResumenComponent implements OnInit {
  private client: GraphQLClient = null;

  // Modales
  @ViewChild('detalleCliente', { static: true }) resumenModal: ModalDirective;
  @ViewChild('auditoriaModal', { static: true }) auditoriaModal: ModalDirective;

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalEmpresa: number;

  // Utils
  private log: any;
  auditoria: AuditoriaInput;
  public clienteSeleccionado: cliente_proveedor | any;
  public clienteSeleccionadoData: any;

  currentTabs: string;

  constructor(
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private auditoriaService: AuditoriaService,
    private clog: ConsoleService,
    public validadores: ValidadoresService,
    public rutService: RutService,
    public toastService: ToastService
  ) {
    this.log = this.clog.log('MANTENEDOR-CLIENTES/RESUMEN');
    this.client = client;
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
  }

  verDetalle(){
    this.currentTabs = "detalle";
  }
  verAuditoria(){
    this.currentTabs = "auditoria";
    this.auditoria = {
      codigoEntidad: this.clienteSeleccionado.rut,
      entidad: 'CLIENTE'
    }
  }

  loadAndShow(cliente: cliente_proveedor) {
    const self = this;
    self.currentTabs = "detalle";
    self.log('detalle', cliente, 'sucursalCliente', Number(self.sucursalEmpresa));

    self.clienteSeleccionado = cliente;
    self.clienteSeleccionado.rutFormato = self.rutService.AgregarDV(cliente.rut);

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $rutCliente: Decimal, $sucursalCliente: Decimal) {
            cliente_proveedor {
              obtenerSegunId(entidad: { rut: $rutCliente, empresa_rut: $rutEmpresa }) {
                respuesta {
                  limite_credito
                  giro
                }
              }
            }

            direccion {
              obtenerSegunFiltroCliente(filtro: { exacto: { cliente_proveedor_rut: $rutCliente, empresa_rut: $rutEmpresa, codigo: $sucursalCliente } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    direccion_completa
                    nombreRegion
                    nombreProvincia
                    localidad
                    nombreComuna
                    email_contacto
                    nombre_contacto
                    es_principal
                    facturar_a_casa_matriz
                    condicion_pago_codigo
                    condicion_pago_nombre
                    activo
                    lunes
                    martes
                    miercoles
                    jueves
                    viernes
                    sabado
                    domingo
                    vendedor_codigo
                  }
                }
              }
            }

            bloqueo_historico {
              obtenerUltimoSegunFiltro(filtro: { exacto: { rut_empresa: $rutEmpresa, rut_cliente_proveedor: $rutCliente } }) {
                respuesta {
                  registros {
                    codigo
                    rut_cliente_proveedor
                    rut_usuario
                    rut_empresa
                    fecha_registro
                    motivo
                    bloqueo
                    fecha
                    hora
                    nombre_usuario
                    glosabloqueo
                  }
                }
              }
            }

            maquina {
              obtenerMaquinasCliente(filtro: { exacto: { empresa_rut: $rutEmpresa, cliente_proveedor_rut: $rutCliente } }) {
                respuesta {
                  registros {
                    empresa_rut
                    numero_placa
                    cliente_proveedor_rut
                    estado_maquina_codigo
                    estado_maquina_nombre
                    tipo_destinatario_codigo
                    tipo_destinatario_nombre
                    nombre
                    fecha_asignacion
                    modelo
                    direccion_codigo
                    direccion_nombre
                    comuna_codigo
                    comuna_nombre
                    provincia_codigo
                    ciudad
                    provincia_nombre
                    region_codigo
                    region_nombre
                  }
                }
              }
            }

            cartola_cliente {
              saldoActualCtaCteCliente(filtro: { exacto: { empresa_rut: $rutEmpresa, cliente_proveedor_rut: $rutCliente, sucursal_codigo: $sucursalCliente } }) {
                respuesta {
                  saldo_cartola
                }
              }
            }

            diferencia_pago {
              obtenerAcumuladoPagoAcuenta(filtro: { exacto: { rut_emisor: $rutEmpresa, sucursal_codigo: $sucursalCliente, cliente_proveedor_rut: $rutCliente } }) {
                respuesta {
                  saldo
                }
              }
            }
          }
        `,
        variables: {
          rutEmpresa: Number(self.rutEmpresa),
          rutCliente: cliente.rut,
          sucursalCliente: Number(self.sucursalEmpresa),
        },
        fetchPolicy: 'no-cache',
      },
      function (_respuesta) {
        const { respuesta: _clienteProveedor } = _respuesta.data.cliente_proveedor.obtenerSegunId;

        // self.clienteSeleccionado = clienteProveedor
        self.clienteSeleccionadoData = {};
        console.log('muestrame datos de cliente ', cliente, _clienteProveedor);
        self.clienteSeleccionadoData.clienteProveedor = cliente;
        self.clienteSeleccionadoData.clienteProveedor.limite_credito = _clienteProveedor.limite_credito;
        self.clienteSeleccionadoData.clienteProveedor.giro = _clienteProveedor.giro;

        // sobreescribir data faltante clienteSeleccionadoData

        // direccion
        const { registros: direcciones } = _respuesta.data.direccion.obtenerSegunFiltroCliente.respuesta;
        self.clienteSeleccionadoData.direcciones = direcciones;
        self.log('self.clienteSeleccionadoData.direcciones', self.clienteSeleccionadoData.direcciones);

        self.clienteSeleccionadoData.direccionPrincipal = {};
        if (direcciones) {
          const _pricipales = direcciones.filter((d) => d.es_principal);
          self.clienteSeleccionadoData.direccionPrincipal = _pricipales ? _pricipales[0] : {};
          self.clienteSeleccionadoData.direccionPrincipal.condicion_pago_nombre = _pricipales[0].condicion_pago_nombre;
          self.clienteSeleccionadoData.direccionPrincipal.email_contacto = _pricipales[0].email_contacto;
          // self.clienteSeleccionadoData.direccionPrincipal = direcciones
        }

        // máquinas
        // self.clienteSeleccionadoData.direcciones : direccion[] = [{}]
        let _maquinas: maquinaJoin[] = [];
        const { registros: maquinas } = _respuesta.data.maquina.obtenerMaquinasCliente.respuesta;
        console.log('muestrame direccion de maquina ', maquinas);
        if (maquinas) _maquinas = maquinas;
        self.clienteSeleccionadoData.maquinas = _maquinas;
        self.log('self.clienteSeleccionadoData.maquinas', self.clienteSeleccionadoData.maquinas);

        // bloqueo histórico
        const { respuesta: bloqueo_historico } = _respuesta.data.bloqueo_historico.obtenerUltimoSegunFiltro;
        // console.log('bloqueo_historico', bloqueo_historico)
        self.clienteSeleccionadoData.ultimoBloqueo = null;
        if (bloqueo_historico.registros && bloqueo_historico.registros.lenght > 0) {
          const data = bloqueo_historico.registros[0];
          // console.log('bloqueo_historico', `${data.fecha} | ${data.hora} | ${data.nombre_usuario} | ${data.glosabloqueo}`)
          self.clienteSeleccionadoData.ultimoBloqueo = `${data.fecha} | ${data.hora} | ${data.nombre_usuario} | ${data.glosabloqueo}`;
        }

        // Resumen
        self.clienteSeleccionadoData.resumen = {};

        // cartola_cliente
        const { respuesta: cartola } = _respuesta.data.cartola_cliente.saldoActualCtaCteCliente;
        // console.log('bloqueo_historico', bloqueo_historico)
        self.clienteSeleccionadoData.resumen.saldo_cartola = cartola ? cartola.saldo_cartola : 0;

        // cartola_cliente
        const { respuesta: diferencia_pago } = _respuesta.data.diferencia_pago.obtenerAcumuladoPagoAcuenta;
        // console.log('bloqueo_historico', bloqueo_historico)
        self.clienteSeleccionadoData.resumen.saldo = diferencia_pago ? diferencia_pago.saldo : 0;

        self.showModalDetalleClienteParte2(
          self.clienteSeleccionadoData.direccionPrincipal ? self.clienteSeleccionadoData.direccionPrincipal.condicion_pago_codigo : -1,
          self.clienteSeleccionadoData.clienteProveedor.tipo_cliente_codigo,
          self.clienteSeleccionadoData.clienteProveedor.tipo_cobro_codigo,
          Number(self.rutEmpresa),
          cliente.rut,
          self.sucursalEmpresa
        );
        // self.resumenModal.show();
      }
    );
  }

  showModalDetalleClienteParte2(condicion_pago_codigo: Number, tipo_cliente_codigo: String, tipo_cobro_codigo: Number, rutEmpresa: Number, rutCliente: Number, sucursalCodigo: Number) {
    const self = this;
    self.log('condicion_pago_codigo', condicion_pago_codigo);
    self.log('tipo_cliente_codigo', tipo_cliente_codigo);
    self.log('tipo_cobro_codigo', tipo_cobro_codigo);
    self.log('rutEmpresa', rutEmpresa);
    self.log('rutCliente', rutCliente);
    self.log('sucursalCodigo', sucursalCodigo);

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $rutCliente: Decimal, $sucursalCodigo: Decimal, $codigo: Decimal, $tipo_cliente_codigo: String, $tipo_cobro_codigo: Decimal) {
            condicion_pago {
              obtenerSegunId(entidad: { codigo: $codigo }) {
                respuesta {
                  codigo
                  rut_empresa
                  sucursal_codigo
                  descripcion
                  cantidad_dias
                  uso_venta
                  uso_compra
                  estado
                  recargoporc
                }
              }
            }

            tipo_cliente {
              obtenerSegunId(entidad: { codigo: $tipo_cliente_codigo, empresa_rut: $rutEmpresa }) {
                mensajes {
                  codigo
                  texto
                }
                respuesta {
                  descripcion
                  idcanal
                }
              }
            }

            canal {
              obtenerTodos {
                respuesta {
                  registros {
                    idcanal
                    descripcion
                  }
                }
              }
            }

            tipo_cobro {
              obtenerSegunId(entidad: { codigo: $tipo_cobro_codigo }) {
                mensajes {
                  codigo
                  texto
                }
                respuesta {
                  codigo
                  descripcion
                }
              }
            }

            documento_no_tributario {
              obtenerSegunFiltroUltimoPedido(filtro: { exacto: { rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalCodigo, direccion_cliente_rut: $rutCliente, tipo_dte_codigo: 2 } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    totalBruto
                    fecha_emision
                  }
                }
              }
            }
          }
        `,
        variables: {
          codigo: condicion_pago_codigo,
          tipo_cliente_codigo: tipo_cliente_codigo,
          tipo_cobro_codigo: tipo_cobro_codigo,
          rutEmpresa: rutEmpresa,
          rutCliente: rutCliente,
          sucursalCodigo: sucursalCodigo,
        },
        fetchPolicy: 'no-cache',
      },
      function (_respuesta) {
        const tipoCliente = _respuesta.data.tipo_cliente.obtenerSegunId.respuesta;
        const canales: any[] = _respuesta.data.canal.obtenerTodos.respuesta.registros;
        const canal = canales.find((c) => c.idcanal === tipoCliente.idcanal);
        self.clienteSeleccionadoData.clienteProveedor = {
          ...self.clienteSeleccionadoData.clienteProveedor,
          canal_idcanal: canal.idcanal,
          canal_descripcion: canal.descripcion,
        }

        const { respuesta } = _respuesta.data.condicion_pago.obtenerSegunId;
        if (self.clienteSeleccionadoData.direccionPrincipal) {
          self.clienteSeleccionadoData.direccionPrincipal.condicion_pago_glosa = '';
          if (respuesta) {
            const { descripcion } = respuesta;
            self.clienteSeleccionadoData.direccionPrincipal.condicion_pago_glosa = descripcion ? descripcion : '';
          }
        }

        const { respuesta: tipoClienteResponse } = _respuesta.data.tipo_cliente.obtenerSegunId;
        if (self.clienteSeleccionadoData.clienteProveedor) {
          self.clienteSeleccionadoData.clienteProveedor.tipo_cliente_glosa = '';
          if (tipoClienteResponse) {
            const { descripcion } = tipoClienteResponse;
            self.clienteSeleccionadoData.clienteProveedor.tipo_cliente_glosa = descripcion ? descripcion : condicion_pago_codigo;
          }
        }

        const { respuesta: tipoCobroResponse } = _respuesta.data.tipo_cobro.obtenerSegunId;
        if (self.clienteSeleccionadoData.clienteProveedor) {
          self.clienteSeleccionadoData.clienteProveedor.tipo_cobro_glosa = '';
          if (tipoCobroResponse) {
            const { descripcion } = tipoCobroResponse;
            self.clienteSeleccionadoData.clienteProveedor.tipo_cobro_glosa = descripcion ? descripcion : condicion_pago_codigo;
          }
        }

        const { respuesta: documentoNoTributarioResponse } = _respuesta.data.documento_no_tributario.obtenerSegunFiltroUltimoPedido;
        if (!self.clienteSeleccionadoData.resumen) self.clienteSeleccionadoData.resumen = {};
        if (documentoNoTributarioResponse && documentoNoTributarioResponse.registros && documentoNoTributarioResponse.registros.length > 0) {
          self.clienteSeleccionadoData.resumen.totalBruto = documentoNoTributarioResponse.registros[0].totalBruto;
          self.clienteSeleccionadoData.resumen.fecha_emision = documentoNoTributarioResponse.registros[0].fecha_emision;
        }
        self.resumenModal.show();
      }
    );
  }

  detalleClientePrint() {
    window.print();
    // this.resumenModal.hide();
  }
}
